import cx from "classnames";
import { t } from "ttag";

import { useSetting } from "metabase/settings";
import { Anchor, Card } from "metabase/ui";

import S from "../AuthButton/AuthButton.module.css";

interface OpenIdButtonProps {
  redirectUrl?: string;
  isCard?: boolean;
}

// a plain anchor rather than a router Link: the flow starts with a server redirect to the identity
// provider, which a client-side route change would never reach
export const OpenIdButton = ({ redirectUrl, isCard }: OpenIdButtonProps) => {
  const providerName = useSetting("openid-provider-name");
  const href = redirectUrl
    ? `/auth/sso/openid?redirect=${encodeURIComponent(redirectUrl)}`
    : "/auth/sso/openid";
  const label = t`Sign in with ${providerName}`;

  return isCard ? (
    <Card component="a" href={href} className={cx(S.link, S.card)}>
      {label}
    </Card>
  ) : (
    <Anchor component="a" href={href} className={S.link} underline="never">
      {label}
    </Anchor>
  );
};
